<template>
  <div :class="cssCls">
    <ms-label
      :style="labelStyle"
      :required="!allowBlank"
    >
      {{ label }}
    </ms-label>

    <ms-date-picker
      v-bind="$attrs"
      :class="{ error: hasError }"
      v-model="value"
    />

    <span
      class="error-msg"
      v-if="hasError"
      v-html="errorMessage"
    />
  </div>
</template>

<script>
import { label, useLabel } from '../utils/label'
import { useValidate, validate, getValidationProps } from '../utils/validate'
import MsDatePicker from '@/components/date-picker'

export default {
  name: 'MsDateField',

  mixins: [label, validate],

  inheritAttrs: false,

  components: {
    MsDatePicker
  },

  setup (props, context) {
    const { labelCls, labelStyles } = useLabel(props)
    const validationObj = useValidate(props, context)
    const validationProps = getValidationProps(validationObj)

    return {
      labelCls,
      labelStyles,
      ...validationProps
    }
  },

  computed: {
    cssCls () {
      const me = this

      return {
        'ms-date-field': true,
        'has-error': me.hasError,
        ...me.labelCls,
        [me.validateCls]: true
      }
    },

    labelStyle () {
      return {
        ...this.labelStyles
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ms-date-field {
  display: inline-block;

  @include field-label();
  @include has(error) {
    :deep(.el-input__inner) {
      border-color: $color-error !important;
    }
  }
  @include error-msg()
}
</style>
